// 计划单状态
const scheduleStatusEnum = {
  DELETED: { key: -1, label: '已删除' },
  SAVED: { key: 1, label: '草稿' },
  AUDITING: { key: 2, label: '待审核' },
  AUDITED: { key: 3, label: '待投放' },
  USING: { key: 4, label: '投放中' },
  CLOSING: { key: 5, label: '已下线' },
  DECLINED: { key: 6, label: '已拒绝' },
  FINISHED: { key: 7, label: '已完成' },
  UNFINISHED: { key: 8, label: '超时未完成' },
  PAUSE: { key: 9, label: '暂停' },
  BUDGET_OVER: { key: 10, label: '预算不足' },
  SETTLEMENT: { key: 11, label: '结算中' }
};
// 素材状态
const checkStatusEnum = {
  DELETED: { key: -1, label: '已删除' },
  SAVED: { key: 0, label: '草稿' },
  AUDITING: { key: 1, label: '待审核' },
  AUDITED: { key: 2, label: '待测试' },
  DECLINED: { key: 3, label: '审核不通过' },
  TESTED: { key: 4, label: '已测试' },
  TESTFAIL: { key: 5, label: '测试不通过' }
};

// 显示位置
const locationTypeOptions = [
  { label: 0, value: '全屏' },
  { label: 10, value: '自定义' },
  { label: 1, value: '上左' },
  { label: 2, value: '上中' },
  { label: 3, value: '上右' },
  { label: 4, value: '中左' },
  { label: 5, value: '居中' },
  { label: 6, value: '中右' },
  { label: 7, value: '下左' },
  { label: 8, value: '下中' },
  { label: 9, value: '下右' }
];
// 显示位置
const locationTypeObj = {
  0: '全屏',
  10: '自定义',
  1: '上左',
  2: '上中',
  3: '上右',
  4: '中左',
  5: '居中',
  6: '中右',
  7: '下左',
  8: '下中',
  9: '下右'
};
// 动画效果
const effectOptions = [
  { label: '0', value: '无' },
  { label: 'effect1', value: '从小变大' },
  { label: 'effect2', value: '移动飘过' },
  { label: 'effect4', value: '从上到下' },
  { label: 'effect5', value: '从下到上' }
];
// 动画效果
const effectObj = {
  '0': '无',
  'effect1': '从小变大',
  'effect2': '移动飘过',
  'effect4': '从上到下',
  'effect5': '从下到上'
};

// 展现型式
const exposureModeOptions = [
  // { label: 0, value: '顺序轮播' },
  { label: 1, value: '随机模式' }
  // {label: 2, value: '权重分配'},
//   { label: 3, value: '限时模式' }
]
// 展现型式
const exposureModeObj = {
  0: '顺序轮播',
  1: '随机模式',
  // 2: '权重分配',
  3: '限时模式'
};
// 自有计划单监测代码使用方式
const codeTypeOptions = [
  { label: 0, value: '不使用' },
  { label: 1, value: '素材通用' },
  { label: 2, value: '区分素材' }
]
// 程序化保价保量监测代码使用方式
const codeTypePDBOptions = [
  { label: 0, value: '不使用' },
  { label: 1, value: '素材通用' }
]
// 监测代码使用方式
const codeTypeObj = {
  0: '不使用',
  1: '素材通用',
  2: '区分素材'
}
// 结算监测类型
const settlementTypeOptions = [
  { label: 0, value: '无', key: '' },
  { label: 1, value: '曝光监测', key: 'trackList' },
  { label: 2, value: '点击监测', key: 'clickTrackList' },
  { label: 3, value: '起播监测', key: 'startTrackList' },
  { label: 4, value: '中点监测', key: 'middleTrackList' },
  { label: 5, value: '结束监测', key: 'endTrackList' }
];
// 结算监测类型
const settlementTypeObj = {
  0: '无',
  1: '曝光监测',
  2: '点击监测',
  3: '起播监测',
  4: '中点监测',
  5: '结束监测'
};
// 监测类型
const trackTypeModelObj = {
  1: 'API',
  2: 'SDK'
}

const trackOptions = [
  { key: 'trackList', name: '曝光监测', queue: 1, type: 'track' },
  { key: 'clickTrackList', name: '点击监测', queue: 2, type: 'track_click' },
  { key: 'startTrackList', name: '起播监测', queue: 3, type: 'track_start' },
  { key: 'middleTrackList', name: '中点监测', queue: 4, type: 'track_middle' },
  { key: 'endTrackList', name: '结束监测', queue: 5, type: 'track_complete' },
  { key: 'pointTrackList', name: '定点监测', queue: 7, type: 'track_point' },
]

const trackTypeObj = trackOptions.reduce((prev, cur) => {
  prev[cur.queue] = cur.key
  return prev
}, { 0: 'none' })

const eventOptions = [
  { key: 'keyEventList', shipType: 'KEY', name: '按键触发' },
  { key: 'autoEventList', shipType: 'AUTO', name: '自动触发' },
  { key: 'voiceEventList', shipType: 'VOICE', name: '语音触发' }
]

const eventEnum = eventOptions.reduce((prev, cur) => {
  prev[cur.shipType] = { ...cur }
  return prev
}, {})

const genTargetEvent = () => {
  return {
    exception: 'no',
    normalData: {
      doWhat: '',
      packageName: '',
      byWhat: '',
      byValue: '',
      paramsList: [],
      privateParams: []
    },
    exceptionData: {
      doWhat: '',
      packageName: '',
      byWhat: '',
      byValue: '',
      paramsList: [],
      privateParams: []
    },
    targetTempId: -1,
    excTargetTempId: -1,
    voiceWord: '',
    feedBack: ''
  }
}

const genTracks = () => {
  return {
    trackList: [], // 曝光监测
    clickTrackList: [], // 点击监测
    startTrackList: [], // 起播监测
    middleTrackList: [], // 中点监测
    endTrackList: [], // 结束监测
    pointTrackList: [], // 定点监测
  }
}

const genTracksLanding = () => {
  return {
    trackListLanding: [], // 曝光监测
    clickTrackListLanding: [], // 点击监测
    startTrackListLanding: [], // 起播监测
    middleTrackListLanding: [], // 中点监测
    endTrackListLanding: [], // 结束监测
  }
}

const genMediaModel = () => {
  return {
    mediaId: undefined,
    mediaName: '',
    mediaIcon: '',
    mediaClassId: 0,
    adMediaClass: { mediaClassName: '' },
    partnerName: '',
    adSpaceName: '',
    duration: '',
    locationType: 0,
    coordinateX: '',
    coordinateY: '',
    effect: '',
    landPage: 0,
    landingPage: '',
    shipType: 'NONE',
    targetEventType: 4,
    targetEvent: genTargetEvent(),
    tipsTempId: undefined,
    tipsDetail: '',
    codeType: 0,
    oringinalCodeType: 0,
    codeTypeDisabled: false,
    tabTrackType: 'trackList',
    ...genTracks(),
    codeTypeLanding: 0,
    creativeTitle: '',
    clickButtonContent: '',
    tabTrackTypeLanding: 'trackList',
    ...genTracksLanding(),
    landingTipsDetail: [''],
    useMobileTrack: 0,
    mobileTrackList: [{ trackTypeModel: 1, serviceProvider: '', code: '' }],
    additionalMediaList: [],
    additionalMediaSaveVOList: [],
  }
}

const genAdditionalMedia = () => {
  return {
    mediaId: undefined,
    mediaName: '',
    mediaIcon: '',
    mediaClassId: 0,
    adMediaClass: { mediaClassName: '' },
    partnerName: '',
    adSpaceName: '',
    duration: '',
    shipType: 'NONE',
    targetEventType: 4,
    targetEvent: genTargetEvent(),
    tipsTempId: undefined,
    tipsDetail: '',
    clickTrackList: [],
  }
}

export {
  locationTypeOptions,
  locationTypeObj,
  effectObj,
  effectOptions,
  exposureModeOptions,
  exposureModeObj,
  codeTypeOptions,
  codeTypeObj,
  settlementTypeOptions,
  settlementTypeObj,
  trackTypeModelObj,
  scheduleStatusEnum,
  checkStatusEnum,
  codeTypePDBOptions,
  trackOptions,
  trackTypeObj,
  eventOptions,
  eventEnum,
  genTargetEvent,
  genTracks,
  genTracksLanding,
  genMediaModel,
  genAdditionalMedia,
}
